import React from 'react'

export default function FilterField({ label, hint, children, className = '' }) {
  return (
    <div className={`flex min-w-0 flex-col gap-1.5 ${className}`}>
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-sm font-semibold text-rb-black dark:text-white">{label}</span>
        {hint && <span className="text-xs text-rb-mat-grey dark:text-gray-400">{hint}</span>}
      </div>
      {children}
    </div>
  )
}
